import cloneDeep from 'lodash.clonedeep';
import { FormTemplate, FormTemplateOption, FormTemplateSection } from 'data/template/template.types';
import { CaseModel } from 'data/case/case.types';
import template from '../template/caseInfoConfirmationTemplate';

export const setTemplateInitialValues = (
  warrantTemplate: FormTemplate,
  currentCase: CaseModel,
  section: string,
  isNokamflcsimEnabled?: boolean,
  isDisplayLocDataInInterceptDropDownEnabled?: boolean,
) => {
  if (template === null) {
    return {};
  }
  const clonedTemplate = cloneDeep(template);

  if (section === 'cfId') {
    (clonedTemplate.cfId as FormTemplateSection).fields.cfId.initial = currentCase.cfId.name;
    (clonedTemplate.cfId as FormTemplateSection).fields.confirmCfId.options =
      [{ label: 'None', value: 'None' }, ...(currentCase.cfOptions as FormTemplateOption[])];
    clonedTemplate.formId = Date.now().toString();
  }

  if (section === 'interceptType') {

    if (!isNokamflcsimEnabled) {
      const { options } = (warrantTemplate.general as FormTemplateSection)?.fields?.caseType;

      if (options) {
        (warrantTemplate.general as FormTemplateSection).fields.caseType.options = options.filter((option) => option.value !== 'QUERY_LOC_FROM_AMF');
      }
    }

    if (!isDisplayLocDataInInterceptDropDownEnabled) {
      const { options } = (warrantTemplate.general as FormTemplateSection)?.fields?.caseType;

      if (options) {
        (warrantTemplate.general as FormTemplateSection).fields.caseType.options = options.filter((option) => option.value !== 'LOC_ONLY_IN_IRI');
      }
    }

    const caseType = ((warrantTemplate.general as FormTemplateSection).fields.caseType.options as FormTemplateOption[])
      .find((option: FormTemplateOption) => option.value === currentCase.type);

    (clonedTemplate.interceptType as FormTemplateSection).fields.type.initial = caseType?.label;

    (clonedTemplate.interceptType as FormTemplateSection).fields.confirmType.options =
      [...(warrantTemplate.general as FormTemplateSection).fields.caseType.options as FormTemplateOption[]];
    clonedTemplate.formId = Date.now().toString();
  }

  return (clonedTemplate[section] as FormTemplateSection).fields;
};
